import { render } from "./UiSearchBox.vue?vue&type=template&id=2aa4ea20&scoped=true"
import script from "./UiSearchBox.vue?vue&type=script&lang=js"
export * from "./UiSearchBox.vue?vue&type=script&lang=js"

import "./UiSearchBox.vue?vue&type=style&index=0&id=2aa4ea20&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa4ea20"]])

export default __exports__